import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem("yt_admin_token");
        if (!token) {
            setUser(false);
            return;
        }
        api.get("/auth/me")
            .then((res) => setUser(res.data))
            .catch(() => {
                localStorage.removeItem("yt_admin_token");
                setUser(false);
            });
    }, []);

    const login = async (email, password) => {
        const res = await api.post("/auth/login", { email, password });
        localStorage.setItem("yt_admin_token", res.data.token);
        setUser(res.data.user);
    };

    const logout = () => {
        localStorage.removeItem("yt_admin_token");
        setUser(false);
    };

    return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
